<template>
  <div>
    <div class="container-fluid my-2">
      <SectionTitle :has-line="true" content="Procedimientos" />
      <div class="row" v-if="!ReadOnly">
        <div class="col-12">
          <MultiSelectionPicker
            :all-items="proceduresOptions"
            :isbgwhite="true"
            :enable-bg-alternate="true"
            :selected-items="innerSelectedProcedures"
            item-type-name="Procedimientos"
            :disabled="ReadOnly"
          />
        </div>
      </div>
      <div v-if="!ReadOnly" class="row mt-3">
        <div class="col-12">
          <Error
            is-alert-mode
            message="Puede seleccionar uno(1) o más procedimientos. Selección múltiple."
          />
        </div>
      </div>
      <div v-if="!ReadOnly" class="row">
        <div class="col-12">
          <Error
            v-if="hasInnerError"
            message="Favor de seleccionar los procedimientos."
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <CustomChipsGroup
            title="Procedimientos seleccionados"
            :selected-items="innerSelectedProcedures"
            object-text="name"
            :disabled="ReadOnly"
            :class="{ 'custom-chips-group': ReadOnly }"
            @itemMarkedForDeletion="removeSelectionProcedures"
          />
        </div>
      </div>
    </div>
    <div v-if="!ReadOnly" class="actions">
      <ActionButton
        i="fas fa-file-plus"
        variant="success m-2"
        @click="save"
      >
        Guardar
      </ActionButton>
    </div>
  </div>
</template>
<script>
import ActionButton from "@/components/common/ActionButton";
import MultiSelectionPicker from "@/components/common/MultiSelectionPicker";
import CustomChipsGroup from "@/components/common/CustomChipsGroup";
import Error from "@/components/common/Error";
import alert from "@/mixin/alert.mixin";
import PeiApi from "./service";
import { modulesName } from "@/modules";
import { SectionTitle } from "@/components/pei/shared";

import { createNamespacedHelpers } from "vuex";
const {
  mapGetters,
  mapMutations,
  mapActions,
  mapState
} = createNamespacedHelpers(modulesName.programServiceModuleName);

export default {
  name: "ProceduresSelection",
  mixins: [alert],
  props: {
    programServiceAreaId: {
      type: [String, Number],
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActionButton,
    MultiSelectionPicker,
    CustomChipsGroup,
    Error,
    SectionTitle
  },
  data() {
    return {
      isSubmitted: false,
      innerSelectedProcedures: []
    };
  },
  computed: {
    ...mapState(["selectedProcedures"]),
    ...mapGetters(["resource", "proceduresOptions"]),
    hasInnerError() {
      return (
        (this.hasError && !this.innerSelectedProcedures.length) ||
        (this.isSubmitted && this.innerSelectedProcedures.length <= 0)
      );
    }
  },
  methods: {
    ...mapMutations(["setProceduresSelection"]),
    async save() {
      this.isSubmitted = true;
      if (this.innerSelectedProcedures.length <= 0) return false;

      const payload = this.innerSelectedProcedures.map(e => ({
        ProgramServiceAreaId: parseInt(this.programServiceAreaId, 10),
        codeId: parseInt(e.id, 10)
      }));

      try {
        await PeiApi.SaveProcedureInfo(payload);
        this.setProceduresSelection(this.innerSelectedProcedures);
        this.$emit('pending-changes', false);

        this.ShowToast(
          this.resource("R03200110"),
          this.resource("R03200109"),
          "success"
        );

        return true;
      } catch (err) {
        this.ShowToast(err, this.resource("R03200108"), "error");
        return false;
      }
    },
    removeSelectionProcedures(item) {
      this.innerSelectedProcedures = this.innerSelectedProcedures.filter(
        e => e.id !== item.id
      );
    }
  },
  watch: {
    selectedProcedures: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.innerSelectedProcedures = [...newValue];
      }
    },
    innerSelectedProcedures: {
      deep: true,
      immediate: false,
      handler(newValue) {
        if (this.selectedProcedures.length != newValue.length) {
          this.$emit('pending-changes', true);
        }
      }
    },
  }
};
</script>
<style scoped lang="scss">
.actions {
  display: flex;
  justify-content: flex-end;
}

::v-deep .custom-chips-group {
  & div.mt-3 {
    margin-top: 0% !important;
  }
  & .chips-container {
    margin-top: 0% !important;
    padding-top: 0% !important;
  }
}
</style>
